module.exports = __webpack_public_path__ + "static/joel-886a78c2de3048c95808a1c59f23f191.jpg";